var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.625 61.375L30.375 49.125C29.625 48.375 28.7083 48 27.625 48C26.5417 48 25.5833 48.4167 24.75 49.25C24 50 23.625 50.9167 23.625 52C23.625 53.0833 24 54 24.75 54.75L40 70.125C40.75 70.875 41.625 71.25 42.625 71.25C43.625 71.25 44.5 70.875 45.25 70.125L75.125 40.25C75.9583 39.4167 76.375 38.4583 76.375 37.375C76.375 36.2917 75.9583 35.3333 75.125 34.5C74.2917 33.75 73.3125 33.3958 72.1875 33.4375C71.0625 33.4792 70.125 33.875 69.375 34.625L42.625 61.375ZM50 100C43.1667 100 36.7083 98.6875 30.625 96.0625C24.5417 93.4375 19.2292 89.8542 14.6875 85.3125C10.1458 80.7708 6.5625 75.4583 3.9375 69.375C1.3125 63.2917 0 56.8333 0 50C0 43.0833 1.3125 36.5833 3.9375 30.5C6.5625 24.4167 10.1458 19.125 14.6875 14.625C19.2292 10.125 24.5417 6.5625 30.625 3.9375C36.7083 1.3125 43.1667 0 50 0C56.9167 0 63.4167 1.3125 69.5 3.9375C75.5833 6.5625 80.875 10.125 85.375 14.625C89.875 19.125 93.4375 24.4167 96.0625 30.5C98.6875 36.5833 100 43.0833 100 50C100 56.8333 98.6875 63.2917 96.0625 69.375C93.4375 75.4583 89.875 80.7708 85.375 85.3125C80.875 89.8542 75.5833 93.4375 69.5 96.0625C63.4167 98.6875 56.9167 100 50 100Z",
    fill: "#266800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.de460f454ef1b41b675bce79d0561fcf.svg";
export { ForwardRef as ReactComponent };